import aesReduxConstants from '../constants';
import productEventActions from './productEventActions';
import notificationActions from './notificationActions';
import soundActions from './soundActions';
import userActions from './userActions';
import severityActions from './severityActions';
import productActions from './productActions';
import clientActions from './clientActions';
import mapActions from './mapActions';

/**
 * PortalActions
 * high level portal actions
 *
 * @namespace portalActionsFactory
 */
const portalActions = function() {
  const factory = {};
  const constants = aesReduxConstants;

  /**
   * Hydrate the data needed for the portal to load data.
   * - product events
   * - notifications
   * - clients available products
   */
  factory.hydratePortal = function() {
    return function(dispatch, getState) {
      const contextState = getState().user.context;

      // show that the hydration is in process
      dispatch({ type: constants.HYDRATE_PORTAL });

      // get severity list
      dispatch(severityActions.getSeverityList());

      // populate client info
      dispatch(userActions.getClientDetails(contextState.clientId));

      // populate the list of active products
      dispatch(productEventActions.getProductList());

      // get the notifications of the navbar
      dispatch(notificationActions.getNotifications());

      // get the list of all products
      dispatch(productActions.getAllProductTypes());

      // get the list of products a client gets
      dispatch(productEventActions.getClientsAvailableProducts());

      // get the list licenses this client has
      dispatch(clientActions.getLicenses());

      // get all of the basemaps
      dispatch(mapActions.getBasemaps());
    };
  };

  /**
   * Generate a generic error to be dispatched to show an error message
   */
  factory.genericError = function(errorMessage) {
    return {
      type: constants.GENERIC_ERROR,
      errorMessage,
    };
  };

  /**
   * Clear messages from the errors reducer
   */
  factory.clearErrorMessages = function() {
    return {
      type: constants.CLEAR_ERRORS,
    };
  };


  return factory;
};

export default portalActions();
